// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class CommentAPI extends MainAPI {
	async getComments(options) {
		return API.get(ENDPOINTS.GET_COMMENTS, options);
	}

	/**
	 * @param {Number} commentId
	 * @return {Object} comment
	 * */
	async getCommentById(commentId) {
		return API.get(`${ENDPOINTS.GET_COMMENTS}/${commentId}`);
	}

	async deleteComment(commentId) {
		return API.delete(`${ENDPOINTS.DELETE_COMMENT}/${commentId}`);
	}
}

export default new CommentAPI();
